import { store, storeActions } from '~/utility/BinSentry-ui-utility';
import { BnModalMixin } from '../../common/bn-modal-mixin';
import { LitEntity, html } from '../../utility/lit-entity';
import './organization-delete-helper';
import '../../common/bn-loading';

class OrganizationDeleteModal extends BnModalMixin(LitEntity) {
  constructor() {
    super();
    this.id = 'organization-delete-modal';
  }

  renderContents() {
    if (!this.entity) {
      return html`<bn-loading></bn-loading>`;
    }

    const beginDelete = this.entity.getActionByName('begin-delete');

    return html`
      <style>
        bn-modal#organization-delete-modal {
          --modal-min-height: 50%;
          --modal-max-height: 95%;
        }
      </style>

      <h3 slot="title">Confirm Deleting Organization</h3>

      <organization-delete-helper
        .href="${beginDelete.href}"
        successtext="Organization has been deleted. Redirecting to organization parent."
        @response="${this._onDeleteResponse}"
      ></organization-delete-helper>
    `;
  }

  _onDeleteResponse() {
    setTimeout(() => {
      const orgId = this.getHref('https://api.binsentry.com/rel/organization-parent');
      store.dispatch(storeActions.navigate('/organizations', { orgId }));
    }, 2000);
  }
}

window.customElements.define('organization-delete-modal', OrganizationDeleteModal);
